module.exports = __webpack_public_path__ + "img/banner.379b3ca5.png";